import React from 'react';
import { Route, Redirect } from 'react-router-dom';

import DefaultLayout from '../pages/_layouts/default';
import LayoutBase from "../pages/Layout";

export default function RouteWrapper({
  component: Component,
  isPrivate,
  ...rest
}) {
  const signed = localStorage.getItem('@user_token');
  const currentPath = window.location.pathname;

  if (signed && (currentPath === '/login' || currentPath === '/register' || currentPath === '/')) {
    return <Redirect to="/dashboard" />;
  } else if (!signed && currentPath === '/') {
    return <Redirect to="/login" />;
  }

  const Layout =
    signed &&
    currentPath !== '/' ?
      LayoutBase : DefaultLayout
  ;

  return (
    <Route
      {...rest}
      render={(props) => (
        <Layout>
          <Component {...props} />
        </Layout>
      )}
    />
  );
}

RouteWrapper.defaultProps = {
  isPrivate: false,
};